<template>
    <div class="custom-tree-node" :class="{'is-disabled': disabled}">
        <div class="tree-node-label"  :title="currentValue">{{ currentValue }}</div>
        <div class="tree-node-action-sheet">
            <div class="tree-node-action-sheet-item" v-for="action in actionSheet"
              :key="action.command">
                <template v-if="show(action)">
                  <template v-if="action && action.confirm">
                      <pop-confirm :content="action.confirm.text" @confirm="onNodeClick(action)">
                        <common-icon  :type="getActionIcon(action)" :size="14" :title="getActionName(action)"></common-icon>
                      </pop-confirm>
                  </template>
                  <template v-else>
                    <common-icon  @click.native.stop="onNodeClick(action)" :type="getActionIcon(action)" :size="14" :title="getActionName(action)"></common-icon>
                  </template>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import PopConfirm from '../widgets/pop-confirm'
import CommonIcon from '../widgets/icons'
export default {
  components: {
    PopConfirm,
    CommonIcon
  },
  props: {
    node: Object,
    data: Object,
    value: {},
    options: Object,
    disabled: Boolean,
    actionSheet: {
      type: Array,
      default () {
        return []
      }
    }
  },
  watch: {
    value () {
      this.currentValue = this.value
    }
  },
  data () {
    return {
      currentValue: '',
      edit: false
    }
  },
  methods: {
    onNodeClick (action) {
      let data = JSON.parse(JSON.stringify(this.data))
      if (action.click && typeof action.click === 'function') {
        action.click(this.data)
      } else {
        this.$emit('command', action.command, {node: JSON.parse(JSON.stringify(this.node)), data})
      }
    },
    getActionIcon (action) {
      if (action.icon && typeof action.icon === 'function') {
        return action.icon(JSON.parse(JSON.stringify(this.data)))
      }
      return action.icon
    },
    getActionName (action) {
      if (action.label && typeof action.label === 'function') {
        return action.label(JSON.parse(JSON.stringify(this.data)))
      }
      return action.label
    },
    show (action) {
      if (action.show && typeof action.show === 'function') {
        return action.show(JSON.parse(JSON.stringify(this.data)))
      }
      if (typeof action.show === 'undefined' || action.show === null) return true
      return !!action.show
    }
  },
  mounted () {
    this.currentValue = this.value
  }
}
</script>

<style lang="less">
@import '../color.less';
.custom-tree-node {
    font-size: 0;
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
    // width: 276px;
    padding-right: 10px;
    .tree-node-action-sheet {
        visibility: hidden;
        opacity: 0;
        display: flex;
        justify-content: flex-end;
        flex: 0 0 30%;
        transition: opacity .3s;
        &-item {
            &:hover {
                color: @primary;
            }
        }
        .tree-node-action-sheet-item + .tree-node-action-sheet-item {
            margin-left: 10px;
        }
    }
    &:hover {
        .tree-node-action-sheet {
            visibility: visible;
            opacity: 1;
        }
    }
}
.tree-node-label {
    font-size: 14px;
    // flex: 0 0 160px;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    text-align: left;
}
.tree-node-status {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    vertical-align: middle;
    margin-right: 10px;
    background: #e3e4e5;
    &.active {
        background: @primary;
    }
    & + .tree-node-label {
        vertical-align: middle;
    }
}
.custom-tree-node.is-disabled {
    .tree-node-label {
        color: rgb(153, 153, 153)
    }
}
</style>



// WEBPACK FOOTER //
// src/components/framework/tree/tree-node.vue